export default (n) => !isNaN(parseFloat(n)) && isFinite(n);
